import * as React from 'react';
import { TotalsContainer } from '../../Totals/containers/TotalsContainer.js';
import '@grandvisionhq/state';
import '../../../models/add-to-cart/add-to-cart.js';
import '../../../models/cart/cart.js';
import '../../../models/subscription/subscription-details.js';
import '../../../models/checkoutState/checkoutState.js';
import '@swc/helpers';
import '../../../utils/cart-count-var.js';
import '../../../utils/cart-id-var.js';
import '@grandvisionhq/utils';
import '@grandvisionhq/commercetools';
import '@grandvisionhq/graphql';
import '../../../utils/get-unrecoverable-validation-errors.js';
import '../../../models/line-item/prescription-glasses.js';
import '../../../utils/get-failure-error-codes.js';
import '@grandvisionhq/common';
import '@grandvisionhq/elements';
import '@grandvisionhq/iris-ui';
import 'classnames';

const CartTotals = ({ isMiniCart  })=>/*#__PURE__*/ React.createElement(TotalsContainer, {
        className: "mini-cart-v2__totals",
        shouldShowSubTotal: true,
        shouldShowTotalDiscount: true,
        shouldHideSubscriptionExplainer: true,
        isMiniCart: isMiniCart
    })
;

export { CartTotals };
//# sourceMappingURL=CartTotals.js.map
